import React, { Component } from 'react'
import { IMG } from '../../themes'
import { DropDownStyle } from './style'
export class DropDown extends Component {
  constructor()
  {
    super()
    this.state = {
      widthDivSearch: 0,
      isShow: false
    }
  }

  componentDidMount() {
    this.setState({
      widthDivSearch: this.containerNode.clientWidth
    })
  }

  displayListSearch = () => {
    const {
      list,
      language
    } = this.props
    return list.map((data, index)=>{
      return (
        <div key={`${index}-search`}
          className={`list-search pointer`}
          onClick={()=>this.onClickList(data)}>
          {data.name[language]}
        </div>
      )
    })
  }

  onClickList = (data) =>{
    const {
      onClickList
    } = this.props
      onClickList(data)
      this.isShow()
  }

  isShow = () =>{
    this.setState((previous)=>({
      isShow: !previous.isShow
    }))
  }

  render () {
    const {
      className = '',
      error,
      value,
      disabled,
      colorTheme,
    } = this.props
    const {
      widthDivSearch,
      isShow
    } = this.state
    return (
      <DropDownStyle colorTheme={colorTheme}>
        <div className={`div-dropDown ${className} ${error? 'dropDown-error':''} ${value!==''? 'text-select':''} ${disabled? 'disabled':''}`}
          ref={(ref) => this.containerNode = ref}
          onClick={()=>{
            if (!disabled)
            {
              this.isShow()
            }
          }}
        >
          {value}
          <div className='sort'>
            <img
              src={IMG['sort.svg']}
              alt='sort'
            />
          </div>
        </div>
        { isShow &&
          <div className='div-select-list'
            style={{width:`${widthDivSearch}px`}}
          >
              {this.displayListSearch()}
          </div>
        }
      </DropDownStyle>
    )
  }
}
